import styled from "styled-components";

const SavedContractorIcon = styled.i.attrs(({ isSelected = false }) => ({
  className: `${isSelected ? "fas" : "far"} fa-heart fa-fw`,
}))`
  color: ${({ theme }) => theme.colors.success()};
`;

export default SavedContractorIcon;
